import { FC } from 'react'
import { marked } from 'marked'
import DOMPurify from 'isomorphic-dompurify'
import clsx from 'clsx'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import editorParser from '@fudgi-packages/editorjs-to-html'

import { IEditorData, splitEditorData, textPartsQuill } from './utils'

import styles from './html-parse-wrap.module.scss'
import quillStyles from './quill.module.scss'
import editorStyles from './editorjs.module.scss'

interface IHtmlParseWrap {
  htmlContent: string
  children: React.ReactNode
  noDivide?: boolean
}

const HTMLParseWrap: FC<IHtmlParseWrap> = ({ htmlContent, noDivide = false, children }) => {
  const content = htmlContent
  let isQuill = false
  let firstHalf = ''
  let secondHalf = ''

  try {
    const parsedData: IEditorData = JSON.parse(htmlContent)
    const splittedData = splitEditorData(parsedData)

    firstHalf = editorParser(splittedData[0])
    secondHalf = editorParser(splittedData[1])
  } catch (err) {
    console.log('Значит статья на quill')
    isQuill = true
    const splittedText = textPartsQuill(content)

    firstHalf = splittedText[0]
    secondHalf = splittedText[1]
  }

  const containerStyles = clsx(styles.container, {
    [quillStyles.quillContainer]: isQuill,
    [editorStyles.editor]: !isQuill,
  })

  if (noDivide) {
    return (
      <div
        className={containerStyles}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(marked.parse(firstHalf.concat(secondHalf)) as string),
        }}
      />
    )
  }
  return (
    <>
      <div
        className={containerStyles}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(marked.parse(firstHalf) as string),
        }}
      />
      {children}
      <div
        className={containerStyles}
        dangerouslySetInnerHTML={{
          __html: DOMPurify.sanitize(marked.parse(secondHalf) as string),
        }}
      />
    </>
  )
}

export default HTMLParseWrap
